import Revealer from '../modules/Revealer';
import '../../styles/pages/_about.scss';
import '../../styles/components/_location-preview.scss';
class PageAbout {
    constructor() {
        this.init();
    }
    init() {
        console.log('UNTUCKit : Template : PageAbout', this);
        Revealer.init();
    }
}
$(() => {
    new PageAbout();
});
